import * as Icon from "@ant-design/icons";
import { GeneralStore } from "../../stores";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/user";

export const SidebarItems = () => {
  const { t } = useTranslation();
  const { user } = GeneralStore();
  const role = user?.role ?? "";

  const hasRequiredRoles = (requiredRoles) => {
    return requiredRoles.includes(role);
  };

  const isDisabled = (requiredRoles) => {
    return !hasRequiredRoles(requiredRoles);
  };

  return [
    {
      key: "/",
      icon: <Icon.HomeOutlined />,
      label: t("sidebar.home"),
      disabled: isDisabled([
        "Süper Admin",
        "Öğretmen",
        "Öğrenci",
        "Koordinatör",
      ]),
    },
    {
      key: "/branslar",
      icon: <Icon.BranchesOutlined />,
      label: t("sidebar.branches"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/egitmenler",
      icon: <Icon.TeamOutlined />,
      label: t("sidebar.teachers"),
      disabled: isDisabled(["Süper Admin", "Koordinatör"]),
    },
    {
      key: "/koordinatorler",
      icon: <Icon.ControlOutlined />,
      label: t("sidebar.coordinators"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/kullanicilar",
      icon: <Icon.UsergroupAddOutlined />,
      label: t("sidebar.users"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/kayit-ol",
      icon: <Icon.FormOutlined className="text-orange-500" />,
      label: (
        <span className="text-orange-500 font-medium">{t("sidebar.register")}</span>
      ),
      disabled: isDisabled(["Süper Admin", "Öğrenci"]),
    },
    {
      key: "/kurs-detay",
      icon: <Icon.ProjectOutlined />,
      label: t("sidebar.courseDetail"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/sorumlu-kurslarim",
      icon: <Icon.CrownOutlined />,
      label: t("sidebar.myResponsibleCourses"),
      disabled: isDisabled(["Öğretmen", "Koordinatör"]),
    },
    {
      key: "/kayitli-kurslarim",
      icon: <Icon.CarryOutOutlined />,
      label: t("sidebar.myRegisteredCourses"),
      disabled: isDisabled(["Öğrenci"]),
    },
    {
      key: "/devamsizliklar",
      icon: <Icon.HistoryOutlined />,
      label: t("sidebar.absences"),
      disabled: isDisabled([
        "Öğretmen",
        "Öğrenci",
        "Süper Admin",
        "Koordinatör",
      ]),
    },
    {
      key: "/duyurular",
      icon: <Icon.BulbOutlined />,
      label: t("sidebar.notices"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/geri-bildirimler",
      icon: <Icon.LikeOutlined />,
      label: t("sidebar.feedback"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/raporlama",
      icon: <Icon.PieChartOutlined />,
      label: t("sidebar.reporting"),
      disabled: isDisabled(["Süper Admin", "Koordinatör"]),
    },
    {
      key: "/istatistik",
      icon: <Icon.BarChartOutlined />,
      label: t("sidebar.statistics"),
      disabled: isDisabled(["Süper Admin"]),
    },
    {
      key: "/profil",
      icon: <Icon.UserOutlined />,
      label: t("sidebar.profile"),
      disabled: isDisabled([
        "Süper Admin",
        "Öğretmen",
        "Öğrenci",
        "Koordinatör",
      ]),
    },
  ];
};

export const ProfileMenuItems = () => {
  const { t } = useTranslation();
  const [, dispatch] = useContext(UserContext);
  const navigate = useNavigate();
  const { logout } = GeneralStore();

  return [
    {
      key: "profil",
      icon: <Icon.UserOutlined size={16} />,
      label: t("sidebar.profile"),
      onClick: () => {
        navigate("/profil");
      },
    },
    {
      key: "logout",
      icon: <Icon.LogoutOutlined className="text-red-500" size={16} />,
      label: t("sidebar.logout"),
      onClick: () => {
        dispatch({ type: "LOGOUT" });
        logout();
        navigate("/giris");
      },
    },
  ];
};
